import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../common/Header';
import Footer from '../common/Footer';
import AccountDeletionBanner from '../AccountDeletionBanner';

const AppLayout = () => {
  return (
    <div className="min-h-screen">
      <Header />
      {/* z-30 matches the sticky Header: the home hero is `relative` and pulled up -72px, so an unstacked banner sits behind it. */}
      <div className="relative z-30 bg-primary">
        <AccountDeletionBanner />
      </div>
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default AppLayout;
